import React from 'react'
import { observer } from 'mobx-react'
import {
  ModalSheet,
  ModalSheetContentDescription,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetHeader,
  ModalSheetContent,
  ModalSheetFooter,
  ModalSheetFooterSpacer,
  ModalSheetFooterButtonGroup,
  ModalSheetContentBlock,
  ModalSheetFooterSection,
} from 'components/ModalSheet'
import SubmitJobDialogViewModel from './SubmitJobDialogViewModel'
import Button from 'components/Button'
import styles from './SubmitJobDialog.sass'
import ErrorBlock from 'components/ErrorBlock'
import { CheckboxInputContainer } from 'components/inputs'

interface SubmitJobDialogProps {
  vm: SubmitJobDialogViewModel
}

export default observer(({ vm }: SubmitJobDialogProps) => {
  return (
    <ModalSheet showing={vm.showing} onRequestClose={vm.close}>
      <ModalSheetHeader withCloseButton />

      <ModalSheetContent>
        <ModalSheetContentBlock dataTest="submit-job-dialog">
          <ModalSheetContentIllustration
            src={require('assets/images/img_invite-people.svg')}
            alt="Illustration of a girl with her laptop and a plus symbol"
          />
          <ModalSheetContentTitle compact>
            <span className={styles.title}>
              You are about to submit this job
            </span>
          </ModalSheetContentTitle>
          <ModalSheetContentDescription compact>
            Are you sure you want to submit? <br />
            The job will routed to{' '}
            <b>
              {vm.job.requestedPro
                ? vm.job.requestedPro.displayName
                : 'the next available Pro'}
              .
            </b>
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>

        <ModalSheetContentBlock></ModalSheetContentBlock>
      </ModalSheetContent>

      {vm.submit.rejected && (
        <ErrorBlock
          error={vm.submit.error || 'Could not submit this job.'}
          onCloseClick={vm.submit.reset}
          tackOn="bottom"
        />
      )}

      <ModalSheetFooter>
        {vm.isBillingEnabled && vm.canUpdateJobAsAdmin && (
          <ModalSheetFooterSection>
            <CheckboxInputContainer
              model={vm}
              field="shouldBillExternal"
              label="Bill external"
            />
          </ModalSheetFooterSection>
        )}
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            type="default"
            onClick={vm.close}
            dataTest="submit-job-dialog-close-button"
          >
            Close
          </Button>
          <Button
            dataTest="submit-job-dialog-submit-button"
            type="primary"
            onClick={vm.submit}
            disabled={vm.submit.pending}
          >
            Submit
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})
